import EChartsReact from 'echarts-for-react';
import React from 'react';
import { generateColors, getValueFromPercent } from 'utils/helpers';
interface IProps {
    type: 'pie' | 'donut';
    showLabel: boolean;
    data: { name: string; value: number; value_percent: number }[];
    total: number;
}
const QuestionPieChart: React.FC<IProps> = ({
    type,
    showLabel,
    data,
    total,
}) => {
    const option = {
        color: generateColors(data.length),
        title: '',
        tooltip: {
            trigger: 'item',
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            formatter: function (params: any) {
                return `
            <strong>${params.name}</strong><br/>
            <span style="display:inline-block;width:10px;height:10px;
            background-color:${params.color};border-radius:50%;margin-right:5px;"></span>
            ${params.name}: <strong>${getValueFromPercent(params.value, total, 0) ?? 0}</strong>
        `;
            },
        },

        legend: {
            icon: 'circle',
            type: 'scroll',
        },
        series: [
            {
                name: 'Thông tin',
                type: 'pie',
                labelLayout: {
                    hideOverlap: true,
                },
                radius: type === 'donut' ? ['45%', '80%'] : '80%',
                label: {
                    show: showLabel,
                    position: 'outside',
                    formatter: '{b}: {c}%',
                    color: '#000',
                },
                data: data
                    .map((item) => {
                        return {
                            value: item.value_percent ?? 0,
                            name: item.name,
                        };
                    })
                    .sort(function (a, b) {
                        return Number(a.value) - Number(b.value);
                    }),
                roseType: type === 'pie' && 'radius',
                labelLine: {
                    lineStyle: {
                        color: 'rgba(255, 255, 255, 0.3)',
                    },
                    smooth: 0.2,
                    length: 10,
                    length2: 20,
                },
                animationType: 'scale',
                animationEasing: 'elasticOut',
                animationDelay: function () {
                    return Math.random() * 200;
                },
            },
        ],
    };

    return (
        <EChartsReact
            notMerge={true}
            style={{
                height: 500,
            }}
            option={option}
        />
    );
};

export default QuestionPieChart;
